<template>
  <div id="map"></div>
</template>

<script>
  import { GaodeMap, Scene } from '@antv/l7'
  import { Choropleth } from '@antv/l7plot'
  import Global from '../Global'

  export default {
    name: 'AreaDisplay',
    mounted() {
      this.initScene()
    },
    data() {
      return {
        // 地图
        map: null,
        // 地图场景
        scene: null
      }
    },
    methods: {
      async initScene() {
        // 只有在地图不存在的时候才需要重新渲染
        if (this.map === null) {
          this.map = new GaodeMap(
            {
              style: 'blank',
              center: [120.19382669582967, 30.258134],
              zoom: 3
            }
          )
        }
        // 只有在场景不存在的时候才重新生成场景
        if (this.scene === null) {
          this.scene = new Scene(
            {
              id: 'map',
              map: this.map
            }
          )
        }
        // 获取行政区列表
        let list = await this.axios({
          methods: 'GET',
          url: 'https://gw.alipayobjects.com/os/alisis/geo-data-v0.1.1/administrative-data/area-list.json'
        })
        // 获得区域病人数量
        let areaNum = await this.axios({
          methods: 'GET',
          url: Global.yunyingUrl + '/service-order/area/getAreaPatientNum'
        })
        areaNum = areaNum.data.data
        // 过滤行政区域列表
        let data = list.data.filter(({ level, parent }) => level === 'district' && parent === 510100)
        data.forEach(element => {
          try {
            areaNum.forEach(item => {
              if (element.adcode === item.adCode) {
                element.value = item.num
                throw new Error('查询完毕')
              }
            })
          } catch (error) {
          }
          if (typeof element.value === 'undefined') {
            element.value = 0
          }
        })
        // 创建图层
        let choropleth = new Choropleth({
          source: {
            data,
            joinBy: {
              sourceField: 'adcode',
              geoField: 'adcode',
            },
          },
          viewLevel: {
            level: 'city',
            adcode: 510100,
          },
          autoFit: true,
          color: {
            field: 'value',
            value: ['#B8E1FF', '#7DAAFF', '#3D76DD', '#0047A5', '#001D70'],
            scale: { type: 'quantize' },
          },
          style: {
            opacity: 1,
            stroke: '#ccc',
            lineWidth: 0.6,
            lineOpacity: 1,
          },
          label: {
            visible: true,
            field: 'name',
            style: {
              fill: '#000',
              opacity: 0.8,
              fontSize: 10,
              stroke: '#fff',
              strokeWidth: 1.5,
              textAllowOverlap: false,
              padding: [5, 5],
            },
          },
          state: {
            active: { stroke: 'black', lineWidth: 1 },
          },
          tooltip: {
            title: '检查信息',
            items: [{field: 'name', alias: '区域：'}, {field: 'value', alias: '检查人数：'}]
          },
          zoom: {
            position: 'bottomright',
          },
          legend: {
            position: 'bottomleft',
          },
        })
        choropleth.addToScene(this.scene)
      }
    },
  }
</script>
<style scoped>
  #map {
  position: relative;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/area_display/AreaDisplay.vue